import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryShowcase from './components/CategoryShowcase';
import LatestUpdates from './components/LatestUpdates';
import TrendingRank from './components/TrendingRank';
import EditorPicks from './components/EditorPicks';
import FaqSection from './components/FaqSection';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '深夜档漫画多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '深夜档专区每日更新，通常集中在晚间上线新章节，收藏本站即可第一时间收到最新深夜档剧情的更新提醒。',
      },
    },
    {
      '@type': 'Question',
      name: '重口味和暗黑向题材有哪些类型？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '涵盖都市诡异、悬疑烧脑、血浆恐怖、猎奇心理、暗黑人性、暗黑格斗与黑暗奇幻等多个方向，剧情带感、画风大胆。',
      },
    },
    {
      '@type': 'Question',
      name: '在嘿嘿漫画网看漫画需要注册账号吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '浏览和阅读公开章节无需注册即可直接观看，使用收藏、追更提醒与评论等功能则建议注册账号。',
      },
    },
    {
      '@type': 'Question',
      name: '为什么有的漫画标注「已完结」？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '「已完结」表示该作品已更新至最终话，可一口气阅读完整剧情；「连载中」的作品仍在持续更新。',
      },
    },
  ],
};

export default function Home() {
  const handleTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />

      <Header />

      <main>
        <Hero />
        <CategoryShowcase />
        <LatestUpdates />
        <TrendingRank />
        <EditorPicks />
        <FaqSection />
      </main>

      <Footer />

      <button
        type="button"
        onClick={handleTop}
        aria-label="返回顶部"
        className="fixed bottom-6 right-6 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
      >
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
      </button>
    </div>
  );
}